<div class="home-container">
  <div class="welcome-content">
    <div class="app-logo">
      <img src="assets/azeapp.png" alt="AzeApp Logo" />
    </div>

    <h1>AzeApp for Android</h1>
    <p class="subtitle">
      Make enquiries, track vehicles, and get faster updates when you use the
      Android app.
    </p>

    <!-- <button class="download-button">
      <i class="fa fa-download"></i>
      Download
    </button> -->
     
    <a
      href="https://play.google.com/store/apps/details?id=com.azeapp.app"
      target="_blank"
      rel="noopener noreferrer"
    >
      <button class="download-button">
        <i class="fa fa-download"></i>
        Download on Play Store
      </button>
    </a>

    <!-- <p class="encryption-note">
      <i class="fa fa-lock"></i>
      Your vehicle enquiries are end-to-end encrypted
    </p> -->
  </div>
</div>
